import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../../core'
import * as client from '../../../../clients'
import * as project from '../project'

export const RESOURCE = {
  payload: {
    canBeOptional: true,
    context: core.dms.models.Attribute.Id.Context.from({
      context: project.RESOURCE.payload.dimension.partialId,
      partialId: project.RESOURCE.payload.partialId,
      type: core.dms.models.Type.Entity,
    }),
    description: 'Client that this project serves',
    isOptional: true,
    name: 'Client',
    partialId: PartialId.Standard.create('client'),
    type: {
      dimensionId: core.dms.models.Dimension.Id.from(client.RESOURCE.payload),
    },
  },
  type: core.quiver.Resource.Type.DmsAttribute,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsAttribute>
